import SoftBadge from 'components/common/SoftBadge';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import ModalSeguimientoLead from './ModalSeguimientoLead';
import { useToast } from 'context/providers/ToastProvider';
const SeccionLeads = ({
    idOrden
}) => {

    const [leadsVinculados, setLeadsVinculados] = useState([]);
    const [showModalSeguimientoLead, setShowModalSeguimientoLead] = useState(false);
    const [idLead, setIdLead] = useState(0);
    const [loading, setLoading] = useState(true);
    const { showErrorToast } = useToast();
    //AUTENTICACION
    const { token, setToken } = useToken();

    //Obtiene las licencias por id
    const ObtenerLeadsVinculados = async () => {
        setLoading(true);

        const response = await fetch("/api/orden/ObtenerLeadsVinculadosOrden/?id=" + idOrden, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
                setLoading(false);
            });

        if (response.ok) {
            const data = await response.json();
            console.log("========== DETALLES LEADS VINCULADOS DE ORDEN ==========");
            console.log("data: ", data);

            setLeadsVinculados(data["table2"])

            setLoading(false);

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setLoading(false);
        }
    };

    /**
     * Obtiene leads al cambiar id
     */
    useEffect(() => {
        setLeadsVinculados([]);

        if (idOrden) {
            ObtenerLeadsVinculados();
        }
    }, [idOrden]); 

    return (
        <>
            <hr></hr>
            {loading ? <Skeleton width={300} count={5} /> :
                <Table responsive="sm" className={"m-0 p-0"}>
                    <thead>
                        <tr>
                            <th># Lead</th>
                            <th>Estatus</th>
                            <th>Vendedor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leadsVinculados.map(
                            (lead, index) => {
                                return (
                                    <tr key={index} className={"m-0 p-0"}>
                                        <td className={"m-0 p-0"}><Link to={"#"} onClick={() => { setIdLead(lead.idLead); setShowModalSeguimientoLead(true); }}>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip style={{ position: 'fixed' }} >
                                                        {lead.vNombre}
                                                    </Tooltip>
                                                }
                                            >
                                                <span className={"m-0 p-0 fs--1" }>{"Lead #" + lead.idLead}</span>
                                            </OverlayTrigger>


                                        </Link></td>
                                        <td className={"m-0 p-0"}><SoftBadge className={ "m-0 p-1"} pill bg={
                                            lead.idEtapa == 1 ? "secondary" :
                                                lead.idEtapa == 2 ? "primary" :
                                                    lead.idEtapa == 3 ? "warning" :
                                                        lead.idEtapa == 4 ? "success" :
                                                            lead.idEtapa == 5 ? "danger" :
                                                                lead.idEtapa == 6 ? "warning" :
                                                                    lead.idEtapa == 7 ? "success" : "success"
                                        }
                                        >
                                            <span className="mb-0 fs--2 p-0">
                                                {lead.vNombreEtapa}
                                            </span>
                                        </SoftBadge></td>
                                        <td className="mb-0 fs--2 p-0">{lead.vNombre}</td>
                                    </tr>
                                    

                                )
                            }
                        )
                        }


                    </tbody>
                </Table>

            }
            <ModalSeguimientoLead
                showModal={showModalSeguimientoLead}
                setShowModal={setShowModalSeguimientoLead}
                idLead={idLead}
                setIdLead={setIdLead}
                leadsVinculados={leadsVinculados}
                setLeadsVinculados={setLeadsVinculados}

            />
        </>
    )
}

SeccionLeads.propTypes = {
    idOrden: PropTypes.string
};


export default SeccionLeads;